<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Information  Calibration Technician</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Activity Location</label>
        <select class="custom-select" [(ngModel)]="Filter_Area" (change)="Change_Filter()">
          <option value="">Select</option>
          <option value="داخل آزمایشگاه">Inside the Laboratory</option>
          <option value="خارج آزمایشگاه">Outside the Laboratory</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Last Name</label>
        <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_ExpertCalibration()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button routerLink="/ExpertCalibrationAdd" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>National ID</th>
              <th>Activity Location</th>
              <th>Responsibility</th>
              <th>Description</th>
              <th>Status</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            |filter:Filter_Area:'area_title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        |filter:Filter_Area:'area_title'
                        ).length
                      }
            ">
             <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td>{{item.melicode}}</td>
              <td>{{item.area_title}}</td>
              <td>{{item.response}}</td>
              <td>{{item.dsc}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">Active</p>
                <p *ngIf="item.del" style="color: crimson;">Inactive</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.creater}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a class="dropdown-item" [routerLink]="['/ExpertCalibrationEdit',{id:item.id}]"><i class="fa fa-edit"></i> Edit </a>
                          <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-lock"></i> Inactive </a>
                          <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-unlock"></i> Active </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">Approve Deactivate Calibration Technician '{{Data_Seleted_Delete.name}}  {{Data_Seleted_Delete.familly}} ' </h4>
     <h4  *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">Approve Activate Calibration Technician '{{Data_Seleted_Delete.name}}  {{Data_Seleted_Delete.familly}} ' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false"  type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Deactivate <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Activate <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
